import React from 'react';
import Chip from '@mui/material/Chip';

const PRIORITY_COLORS = {
  high: '#e53935',
  normal: '#fb8c00',
  low: '#43a047',
  default: '#bdbdbd',
};

const PRIORITY_LABELS = {
  high: 'Высокий',
  normal: 'Средний',
  low: 'Низкий',
};

export default function PriorityChip({ priority }) {
  const color = PRIORITY_COLORS[priority] || PRIORITY_COLORS.default;
  const label = PRIORITY_LABELS[priority] || priority || '—';
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        backgroundColor: color,
        color: '#fff',
        fontWeight: 500,
        textTransform: 'none',
        letterSpacing: 0,
      }}
    />
  );
}
